<template>
    <div class="container">

        <section v-if="showForm" class="buatTiket" id="buatTiket" ref="buatTiket">
            <h3>Buat Tiket Baru</h3>

            <label for="perihal">Perihal</label>
            <select id="perihal" name="reason" v-model="listForm.perihal" @change="pilihReason">
                <option value="0">-- Pilih alasan --</option>
                <option value="1">Revisi masa berlaku pengesahan</option>
                <option value="2">Penambahan jangka waktu HPK</option>
                <option value="3">Revisi indeks perpanjangan</option>
                <option value="4">Nomor paspor / kewarganegaraan</option>
                <option value="5">Kesalahan nama TKA (typo)</option>
                <option value="6">Upload ulang foto TKA</option>
                <option value="7">Update NPWP</option>
                <option value="8">Verifikasi akun pemberi kerja</option>
                <option value="9">Jabatan tidak tersedia</option>
                <option value="10">Nomor HPK sebelumnya</option>
                <option value="11">Rentang waktu pengesahan</option>
                <option value="12">Perubahan identitas / alamat tinggal / pelengkap nama TKA</option>
                <option value="13">Hal-hal lainnya</option>
            </select>

            <div class="item-inputan" v-for="(item, i) in listInputan" :key="i">
                <label>{{ item.label }}</label>
                <input type="text" v-if="item.type == 'text'" v-model="listForm[item.label]"
                    :placeholder="'Masukkan ' + item.label">

                <input type="file" accept=".jpg,.jpeg,.png,.webp,.pdf" v-if="item.type == 'file'"
                    @change="handleFormFile($event, item.label)">

                <textarea v-if="item.type == 'textarea'" v-model="listForm[item.label]"
                    @input="cekPanjangTeks(listForm[item.label], item.label)" placeholder="maksimal 1000 huruf" rows="5"
                    style="width: 100%;"></textarea>
            </div>

            <button class="buat" ref="btnBuatTiket" :disabled="isloading" @click="buatTiket">
                {{ isloading ? "Memproses..." : "Buat Tiket" }}
            </button>

            <button class="batal" :disabled="isloading" @click="batalBuatTiket">Batal Buat Tiket</button>
        </section>


        <div class="side">
            <div class="top">
                <img class="logokemnaker" src="@/assets/logo single.png" alt="">
                <input type="text" name="" id="" v-model="inputCari" placeholder="cari riwayat disini"
                    @input="cariChat" />
                <div class="filter-wrap">
                    <button>Semua</button>
                    <button>Filter</button>
                </div>
                <button id="tktBaru" @click="bukaFormTiketBaru">Buat Tiket Baru</button>
                <h3>Riwayat Tiket</h3>
            </div>
            <div class="tikets">
                <div class="card-tiket" @click="bukaTiket(item.no_tiket, i, item.id, item.status, item)"
                    v-for="(item, i) in filtered" :key="i">
                    <h5>{{ item.no_tiket }}</h5>
                    <p>
                        {{ item.messages[item.messages.length - 1].message }}
                    </p>
                    <p><small> {{ item.messages[item.messages.length - 1].sent_at }} </small></p>
                </div>
            </div>
        </div>

        <div class="containAll">
            <div class="top">
                <div class="info">
                    <!-- <div class="ic">
                        <i class="fas fa-exclamation"></i>
                    </div>
                    <p>informations</p> -->
                </div>

                <div class="userProfile" @click="(settingstate === false) ? settingstate = true : settingstate = false">
                    <p>{{ accountStore.perusahaan.nama_perusahaan }}</p>
                    <img v-if="accountStore.detailUser.image != null" :src="[`${serverBackend}${datauser.image}`]"
                        alt="">
                </div>

                <div class="settings" v-if="settingstate">
                    <div class="logout item-settings" @click="logout">
                        <p>logout akun</p>
                    </div>
                </div>
            </div>

            <div class="bot">
                <div class="chats parent" ref="parent">

                    <!-- <div v-for="(msg, i) in messages" :key="i">{{ msg }}</div> -->
                    <div v-for="(msgObj, i) in messages" :key="i"
                        :class="[roleId(msgObj.sender.role_id) + '-chat', 'chat-card']">
                        <div class="msg">
                            <div class="profile-img">
                                <!-- <img v-if="[1, 2].includes(msgObj.sender.role_id)" src="@/assets/img/profil/agent.avif"
                                    alt=""> -->
                            </div>

                            <div class="msg-main">
                                <div class="head">
                                    <p v-if="[1, 2].includes(msgObj.sender.role_id)" class="name">{{
                                        msgObj.sender.username }}</p>
                                    <p class="timedate"><small>{{ msgObj.sent_at }}</small></p>
                                </div>

                                <div class="body">
                                    {{ msgObj.message }}
                                </div>

                                <div class="footer" v-if="msgObj.gambar_pengaduan">
                                    <span>
                                        <img :src="bukaGambar(msgObj.gambar_pengaduan)" alt="">
                                    </span>
                                </div>
                                <div class="file-footer" v-if="msgObj.file_pengaduan"
                                    @click="bukaDokumenFile(msgObj.file_pengaduan)">
                                    <div class="ic-file">
                                        <i
                                            :class="[`fas fa-file-${cekTipeFile(getNamaFile(msgObj.file_pengaduan))}`]"></i>
                                    </div>
                                    <div class="detail">
                                        <p>{{ getNamaFile(msgObj.file_pengaduan) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="agent-chat chat-card" v-if="ontyping && ontypingtiket == activeTicket">
                        <div class="msg">
                            <div class="profile-img">
                                <img src="@/assets/img/profil/agent.avif" alt="">
                            </div>

                            <div class="msg-main">
                                <div class="head">
                                    <p class="name">{{ typingAgent }}</p>
                                </div>

                                <div class="body">
                                    sedang mengetik....
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="closed-ticket-msg" v-if="activeTicket && currentTicketStatus == 'closed'">
                        Tiket sudah ditutup oleh agen, silahkan membuat tiket baru untuk berkomunikasi sesuai dengan
                        permasalahan yang dialami. Terima kasih.
                    </div>
                </div>
                <div class="chat-col"
                    v-if="activeTicket && (currentTicketStatus == 'open' || currentTicketStatus == 'baru' || currentTicketStatus == 'in_progress')">
                    <textarea v-model="tempchat" name="" @input="typingChat" placeholder="ketik pesanmu di sini ya"
                        id=""></textarea>
                    <!-- <input type="text" v-model="tempchat" name="" id="" placeholder="ketik pesanmu di sini ya"> -->
                    <div class="btns">
                        <button @click="addMessage"><i class="fad fa-paper-plane"></i></button>
                        <button @click="addFile('dok')"><i class="fad fa-file"></i></button>
                        <button @click="addFile('img')"><i class="fad fa-image"></i></button>
                        <input type="file" ref="fileInput" :accept="fileacceptlist" :key="fileacceptlist"
                            style="display: none" multiple @change="handleFileUpload" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="image-wrap" v-if="imgPreviewState">
        <div class="image-preview">
            <div class="tutup" @click="tutupImagePreview">
                <i class="fas fa-times"></i>
            </div>
            <img @click="zoomImg" v-if="filePreview" :src="filePreview" :style="{ objectFit: objectFitStyle }"
                alt="Preview" />
            <div class="btns">
                <button @click="kirimFile()">Kirim gambar</button>
                <button @click="addFile('img')">Ganti gambar</button>
            </div>
        </div>
    </div>

    <div class="file-wrap" v-if="fileUploadList">
        <div class="top">
            <h3>Files yang akan diupload</h3>

            <div class="file-card" v-for="(item, key) in fileUploadList" :key="key">
                <div :class="['file-icon ', cekTipeFile(item.name)]">
                    <i :class="[`fad fa-file-${cekTipeFile(item.name)}`]"></i>
                </div>
                <div class="detail">
                    <p>{{ item.name }}</p>
                    <p><small> {{ item.size < 1048576 ? (item.size / 1024).toFixed(2) + ' KB' : (item.size /
                        1048576).toFixed(2) + ' MB' }}</small>
                    </p>
                </div>
                <div class="del" @click="hapusFile(key)">
                    <i class="fal fa-trash-can"></i>
                </div>
            </div>

        </div>
        <div class="bot">
            <div class="wrap-button">
                <button @click="tutupFile()">batal kirim</button>
                <button @click="kirimFile()">kirim file</button>
            </div>
        </div>
    </div>
</template>

<script>
import { io } from "socket.io-client";
import axios from "axios"
import { backend, backend as be, websocket as ws } from "@/assets/config/server.js"
import { getCookie } from "@/assets/config/cookie";
import Swal from 'sweetalert2'
import api2 from "@/services/api";
import { useAccountStore } from "@/store/account";
import { postdata } from "@/utils/userchatcontrol";
import { kirimsinglefile } from "@/utils/filescontrol";
//import { logAction } from "@/assets/config/logging";

const socket = io(ws);
const alasanList = [
    "-- Pilih alasan --",
    "Revisi masa berlaku pengesahan",
    "Penambahan jangka waktu HPK",
    "Revisi indeks perpanjangan",
    "Nomor paspor / kewarganegaraan",
    "Kesalahan nama TKA (typo)",
    "Upload ulang foto TKA",
    "Update NPWP",
    "Verifikasi akun pemberi kerja",
    "Jabatan tidak tersedia",
    "Nomor HPK sebelumnya",
    "Rentang waktu pengesahan",
    "Perubahan identitas / alamat tinggal / pelengkap nama TKA",
    "Hal-hal lainnya"
];


export default {
    name: "MainDashboard",
    props: {
        msg: String,
    },
    data() {
        return {
            form: {
                desc: "",
                perihal: 0
            },
            serverBackend: be,
            keys: null,
            settingstate: false,
            inputCari: null,
            showForm: false,
            activeTicket: null,
            lastKey: null,
            temptiket: {},
            tempmsg: [],
            tempchat: [],
            messages: [],
            file: null,
            filePreview: null,
            jenisBtn: null,
            currentIndex: 0,
            objectFitStyle: "contain",

            allmsg: {
            },

            tickets: [

            ],
            datauser: {
                nama: "",
                tipe: 0,
                foto: "user2.png",
                email: "",
                npwp: ""
            },
            dataperusahaan: {},
            rawData: {},
            currentIdTiket: 0,
            fileImg: {},
            imgState: null,
            imgPreviewState: false,
            listInputan: [],
            listForm: {
                perihal: 0
            },
            fileUploadList: null,
            fileacceptlist: "",
            currentNoTiket: null,
            filtered: [],
            ontyping: false,
            ontypingtiket: null,
            typingAgent: null,
            isloading: false,
            currentTicketStatus: "open",
            currentwholetiket: null,
            accountStore: useAccountStore()
        };
    },
    mounted() {
        // const tempdatauser = JSON.parse(getCookie("userinfo") || "{}");
        // this.datauser = {
        //     nama: tempdatauser.perusahaan.nama_perusahaan,
        //     tipe: 0,
        //     foto: (tempdatauser.image.includes(be)) ? tempdatauser.image : `${be}/storage/${tempdatauser.image}`,
        //     id: tempdatauser.id,
        //     email: tempdatauser.perusahaan.email,
        //     npwp: tempdatauser.perusahaan.npwp,
        //     username: tempdatauser.username
        // }

        this.datauser = this.accountStore.detailUser
        this.dataperusahaan = this.accountStore.perusahaan

        //console.log(this.accountStore)

        this.getchat()

        if (this.tickets.length < 1) {
            //const firstKey = 0
            this.messages = []

            this.lastKey = 0
            this.activeTicket = 0
        } else {
            const firstKey = this.tickets[0].tiket
            this.messages = this.allmsg[firstKey]

            this.lastKey = this.tickets[0].tiket
            this.activeTicket = this.firstKey
        }
        //console.log(parseInt(this.lastKey))
        const cekTiket = (noTiket) => {
            var i = 0
            for (const element of this.tickets) {
                if (noTiket == element.no_tiket) {
                    return { status: true, index: i }
                }
                i++
            }

            return { status: false, index: i }
        }

        socket.on("balastyping", (msg) => {
            this.ontyping = true
            this.ontypingtiket = msg.no_tiket
            this.typingAgent = msg.username
            this.scrollToBottom()
        })

        socket.on("balasendtyping", (msg) => {
            this.ontyping = false
            this.ontypingtiket = msg.no_tiket
            this.typingAgent = msg.username
            this.scrollToBottom()
        })

        socket.on("balasMessage", (msg) => {
            const currentMsg = msg
            //console.log(currentMsg)
            this.tempmsg = {
                sender: { role_id: 1, username: currentMsg.sender.username },
                type: 1,
                message: currentMsg.message,
                sent_at: this.dateNow(),
                file: null,
                img: null,
                file_pengaduan: currentMsg.file_pengaduan,
                gambar_pengaduan: currentMsg.gambar_pengaduan,
                tiket_id: currentMsg.tiket_id,
                no_tiket: currentMsg.no_tiket
            }

            //this.messages.push(this.tempmsg);
            const tiketState = cekTiket(msg.no_tiket)

            if (tiketState.status) {
                this.allmsg[msg.no_tiket].push(this.tempmsg)
                //this.tickets
                //this.messages.push(this.tempmsg);
                this.tempchat = ""
                this.tempmsg = []
                this.tickets.unshift(this.tickets.splice(parseInt(tiketState.index), 1)[0]);
            }
        })

        socket.on("closeTicket", (msg) => {
            const tiket = msg.no_tiket;

            let i = 0
            for (const item of this.tickets) {
                if (item.no_tiket == tiket) {
                    this.tickets[i].status = "closed"
                    break
                }
                i++
            }

            // jika tiket yang dihapus adalah tiket aktif
            if (this.activeTicket === tiket) {
                this.currentTicketStatus = 'closed'
            }
            if (this.inputCari == "" || this.inputCari == null) { this.filtered = this.tickets }
            //console.log(this.tickets)
        });

        if (this.inputCari == "") { this.filtered = this.tickets }
        this.scrollToBottom();


    },
    updated() {
        this.scrollToBottom(); // auto scroll setiap pen baru
    },
    methods: {
        // lastMsg(list,len){

        // },
        formatSimple(iso) {
            return iso.replace('T', ' ').slice(0, 19)
        },
        cekPanjangTeks(text, temp = null) {
            if (text.length > 1000) {
                if (temp) {
                    this.listForm[temp] = text.substring(0, 1000);
                } else {
                    this.tempchat = text.substring(0, 1000);
                }
                Swal.fire({
                    icon: "warning",
                    title: "Batas Teks Tercapai",
                    text: "Maksimal 1000 huruf diperbolehkan.",
                    timer: 1000,
                    showConfirmButton: false
                });
            }
            return false
        },
        typingChat() {
            this.cekPanjangTeks(this.tempchat)
            socket.emit("typing", {
                no_tiket: this.activeTicket,
                username: this.datauser.nama,
                status: 1
            })
            clearTimeout(this.typingTimeout);
            this.typingTimeout = setTimeout(() => {
                socket.emit("endtyping", {
                    no_tiket: this.activeTicket,
                    username: this.datauser.nama,
                    status: 0
                })
            }, 3000);
        },
        tutupFile() {
            this.fileUploadList = null
        },
        async logout() {
            window.location.href = 'https://tka-online.kemnaker.go.id/apl/account/logout'
            // const sessionToken = getCookie("token");

            // // 1️⃣ Hapus cookie dulu (langsung logout dari sisi client)
            // deleteCookie('userinfo');
            // deleteCookie('token');
            // deleteCookie('namaPerusahaan');
            // deleteCookie('statusPerusahaan');

            // // 2️⃣ Langsung arahkan user ke halaman login
            // this.$router.push("/");

            // // 3️⃣ Panggil logout API di background (tidak menunggu hasil)
            // setTimeout(() => {
            //     axios.post(`${be}/api/logout`, {}, {
            //         headers: {
            //             Accept: "application/json",
            //             Authorization: `Bearer ${sessionToken}`,
            //         },
            //     }).catch(err => console.error("Gagal logout server:", err));
            // }, 300);
        },

        getNamaFile(name) {
            let temp = name.split("/");
            return temp[temp.length - 1]
        },
        cariChat() {
            this.filtered = this.tickets.filter(ticket => {
                const matchNama = ticket.nama_perusahaan.toLowerCase().includes(this.inputCari)
                const matchTiket = ticket.no_tiket.toLowerCase().includes(this.inputCari)
                const matchGambar = ticket.messages.some(msg =>
                    msg.gambar_pengaduan && msg.gambar_pengaduan.toLowerCase().includes(this.inputCari)
                )
                const matchFile = ticket.messages.some(msg =>
                    msg.file_pengaduan && msg.file_pengaduan.toLowerCase().includes(this.inputCari)
                )
                const matchMessage = ticket.messages.some(msg =>
                    msg.message && msg.message.toLowerCase().includes(this.inputCari)
                )
                return matchNama || matchMessage || matchTiket || matchGambar || matchFile
            })

        },
        cekTipeFile(name) {
            let temp = name.split(".");

            switch (temp[temp.length - 1].toLowerCase()) {
                case "pdf":
                    return "pdf"
                case "xlsx":
                    return "excel"
                case "xls":
                    return "excel"
                case "csv":
                    return "excel"
                case "doc":
                    return "word"
                case "docx":
                    return "word"
                default:
                    return ""
            }
            //return temp[temp.length - 1].toLowerCase();
        },
        async aksesApi(api) {
            const sessionToken = getCookie("token");
            try {
                const res = await axios.get(
                    `${be}/${api}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    }
                );
                //console.log(res.data)
                return await res.data
            } catch (err) {
                console.error(err)
            }
        },
        async kirimApi(api) {
            const sessionToken = getCookie("token");
            try {
                const res = await axios.get(
                    `${be}/${api}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    }
                );
                //console.log(res.data)
                return await res.data
            } catch (err) {
                console.error(err)
            }
        },
        async pilihReason() {
            const reason = this.listForm.perihal
            const username = this.accountStore.user

            const reasons = await api2.get(`api/detail-kategori-pengaduan1/${reason}`, {
                params: {
                    username: username
                }
            }) //this.aksesApi(`api/detail-kategori-pengaduan/${reason}`)

            //console.log(reasons)
            this.listInputan = reasons.data.syarat
        },
        bukaDokumenFile(data) {
            if (data.includes(backend)) {
                window.open(data, '_blank')
            } else {
                window.open(`${backend}/storage/${data}`, '_blank')
            }

        },

        bukaGambar(data) {
            if (data.includes(backend)) {
                return (data)
            } else {
                return (`${backend}/storage/${data}`)
            }
        },
        handleFormFile(event, label) {
            const selectedFile = event.target.files[0];
            if (!selectedFile) return;
            const fileSizeMB = selectedFile.size / (1024 * 1024);
            if (fileSizeMB > 2) {
                Swal.fire({
                    icon: "error",
                    title: "Ukuran File Terlalu Besar",
                    text: "Maksimal ukuran file adalah 2 MB!",
                });
                event.target.value = null;
                return;
            } else {
                this.listForm[label] = event.target.files[0]
            }
            //this.listForm[label] = event.target.files[0] // pakai key string, aman meskipun ada spasi
        },
        zoomImg() {
            this.objectFitStyle = this.objectFitStyle === "contain" ? "cover" : "contain"
        },
        dateNow() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, "0"); // bulan mulai dari 0
            const day = String(now.getDate()).padStart(2, "0");

            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        async getchat() {
            //const sessionToken = getCookie("token");
            const username = this.accountStore.user
            const perusahaanid = this.accountStore.perusahaan.id
            try {
                const res = await api2.get("/api/perusahaan/tiket1", {
                    params: { username: username, perusahaanid: perusahaanid }
                })

                //console.log(res)
                // const res = await axios.get(
                //     `${be}/api/perusahaan/tiket`,
                //     {
                //         headers: {
                //             Accept: "application/json",
                //             Authorization: `Bearer ${sessionToken}`,
                //         },
                //     }
                // );

                this.tickets = res.data.tiket
                this.filtered = this.tickets
                this.allmsg = this.msgCollect(this.tickets)
                // console.log(this.filtered)
            } catch (err) {
                //logAction(`${this.datauser.nama} gagal ambil pesan ${JSON.stringify(err)}`)
                console.error(err)
            }
        },
        msgCollect(data) {
            let msgs = {}

            for (const element of data) {
                const tempmsg = element.messages
                msgs[element.no_tiket] = tempmsg
            }

            return msgs
        },
        roleId(id) {
            switch (id) {
                case 1:
                    return "agent"
                case 2:
                    return "agent"
                case 3:
                    return "user"

                default:
                    break;
            }
        },
        bukaFormTiketBaru() {
            this.showForm = true
        },
        bukaTiket(tiket, index, id, status, wholetiket) {
            this.messages = []
            this.messages = this.allmsg[tiket]
            this.activeTicket = tiket
            this.currentIndex = index
            this.currentIdTiket = id
            this.currentTicketStatus = status
            this.currentwholetiket = JSON.parse(JSON.stringify(wholetiket))

        },
        batalBuatTiket() {
            this.showForm = false
            this.isloading = false
            this.listForm = {
                perihal: 0
            }

            this.listInputan = {}
        },
        async buatTiket() {
            // Disable tombol saat diklik
            // if (this.checkWorkingHours() === false) {
            //     return
            // }

            this.isloading = true;
            this.$refs.btnBuatTiket.disabled = true;

            const username = this.accountStore.user

            // === 1️⃣ VALIDASI FORM ===
            // Validasi perihal
            if (!this.listForm.perihal || this.listForm.perihal == "0") {
                Swal.fire({
                    icon: "warning",
                    title: "Perhatian!",
                    text: "Silakan pilih perihal terlebih dahulu.",
                });
                this.isloading = false;
                this.$refs.btnBuatTiket.disabled = false;
                return;
            }

            if (this.listForm["Deskripsi"]) {
                var temp = this.listForm["Deskripsi"]
                temp = temp.replaceAll(" ", "")
                if (temp == "") {
                    Swal.fire({
                        icon: "warning",
                        title: "Perhatian!",
                        text: "Silakan pilih perihal terlebih dahulu.",
                    });
                    this.isloading = false;
                    this.$refs.btnBuatTiket.disabled = false;
                    return
                }
            }

            const cekjenisinputan = (list, label) => {
                for (const el of list) {
                    if (el.label == label) {
                        return el.type
                    }
                }

                return null
            }

            // Validasi semua field di listInputan
            for (const item of this.listInputan) {
                //if(cekjenisinputan())
                const value = (item.type == 'text') ? `${item.label} ${this.listForm[item.label]}` : this.listForm[item.label];

                if (!value || value === "") {
                    Swal.fire({
                        icon: "warning",
                        title: "Form Belum Lengkap",
                        text: `Field "${item.label}" tidak boleh kosong.`,
                    });
                    this.isloading = false;
                    this.$refs.btnBuatTiket.disabled = false;
                    return;
                }

                // Jika tipe file, cek ukuran max 2MB
                if (item.type === "file" && value && value.size > 2 * 1024 * 1024) {
                    Swal.fire({
                        icon: "error",
                        title: "Ukuran File Terlalu Besar",
                        text: `File pada "${item.label}" melebihi 2MB.`,
                    });
                    this.isloading = false;
                    this.$refs.btnBuatTiket.disabled = false;
                    return;
                }
            }

            //console.log(this.listForm)
            // === 2️⃣ LANJUT PROSES BUAT TIKET ===
            try {
                //const sessionToken = getCookie('token');
                const result = await this.createTicket();
                this.currentIdTiket = result.tiket_id;

                const listImg = ['png', 'jpg', 'jpeg', 'webp'];
                const currentFileType = (name) => name.split('.').pop().toLowerCase();

                for (const key in this.listForm) {
                    let value = this.listForm[key];
                    let listMsgVal = { msg: null, img: null, file: null };
                    let sendFiles = null;

                    // Jika isian berupa file/gambar
                    const formData = new FormData();
                    formData.append("username", username);

                    if (typeof value === 'object' && value !== null) {
                        if (listImg.includes(currentFileType(value.name))) {
                            listMsgVal.img = value;
                            formData.append("gambar", value);


                            // sendFiles = await axios.post(
                            //     `${be}/api/chat/${this.currentIdTiket}/send`,
                            //     { gambar: value },
                            //     {
                            //         headers: {
                            //             Accept: "application/json",
                            //             "Content-Type": "multipart/form-data",
                            //             Authorization: `Bearer ${sessionToken}`,
                            //         },
                            //     }
                            // );

                            sendFiles = await api2.post(
                                `/api/chat/${this.currentIdTiket}/send1`,
                                formData
                            )

                            listMsgVal.img = sendFiles.data.pengaduan.gambar_pengaduan;
                        } else {
                            listMsgVal.file = value;
                            formData.append("file", value);

                            // sendFiles = await axios.post(
                            //     `${be}/api/chat/${this.currentIdTiket}/send`,
                            //     { file: value },
                            //     {
                            //         headers: {
                            //             Accept: "application/json",
                            //             "Content-Type": "multipart/form-data",
                            //             Authorization: `Bearer ${sessionToken}`,
                            //         },
                            //     }
                            // );

                            sendFiles = await api2.post(
                                `/api/chat/${this.currentIdTiket}/send1`,
                                formData
                            )

                            listMsgVal.file = sendFiles.data.pengaduan.file_pengaduan;
                        }

                        //console.log(sendFiles)

                    } else {
                        // Jika isian berupa teks
                        let tempdata = null

                        if (['text', 'textarea'].includes(cekjenisinputan(this.listInputan, key))) {
                            tempdata = `${key} ${value}`;
                        } else if (key == 'perihal') {
                            tempdata = alasanList[parseInt(value)]
                        } else {
                            tempdata = value;
                        }
                        // sendFiles = await axios.post(
                        //     `${be}/api/chat/${this.currentIdTiket}/send`,
                        //     { message: tempdata },
                        //     {
                        //         headers: {
                        //             Accept: "application/json",
                        //             Authorization: `Bearer ${sessionToken}`,
                        //         },
                        //     }
                        // );

                        const username = this.accountStore.user

                        sendFiles = await api2.post(
                            `/api/chat/${this.currentIdTiket}/send1`,
                            {
                                message: tempdata,
                                username: username
                            }
                        )
                        if (['text', 'textarea'].includes(cekjenisinputan(this.listInputan, key))) {
                            listMsgVal.msg = `${key} ${value}`;
                        } else if (key == 'perihal') {
                            listMsgVal.msg = alasanList[parseInt(value)]
                        } else {
                            listMsgVal.msg = value;
                        }
                    }

                    // Kirim langsung tiap item ke socket
                    socket.emit("chatMessage", {
                        id: result.tiket_id,
                        sender: this.dataperusahaan.nama_perusahaan,
                        type: 0,
                        tiket: result.no_tiket,
                        msg: listMsgVal.msg,
                        status: 'open',
                        file_pengaduan: listMsgVal.file,
                        gambar_pengaduan: listMsgVal.img,
                        date: this.dateNow(),
                        senderType: "user",
                        id_tiket: result.tiket_id,
                        userImg: this.datauser.foto,
                        email: this.datauser.email,
                        npwp: this.datauser.npwp,
                        kategori: result.kategori_nama,
                        perusahaan: {
                            nama_perusahaan: this.dataperusahaan.nama_perusahaan,
                            username: this.datauser.username

                        },
                        wholetiket: {
                            id: result.tiket_id,
                            no_tiket: result.no_tiket,
                            messages: [],
                            perusahaan: {
                                nama_perusahaan: this.dataperusahaan.nama_perusahaan,
                                username: this.datauser.username

                            },
                            onepengaduan: {
                                name: result.kategori_nama,
                            }
                        }
                    });

                    // console.log({
                    //     id: result.pengaduan.id,
                    //     sender: this.datauser.nama,
                    //     type: 0,
                    //     tiket: result.no_tiket,
                    //     msg: listMsgVal.msg,
                    //     file_pengaduan: listMsgVal.file,
                    //     gambar_pengaduan: listMsgVal.img,
                    //     date: sendFiles.data.pengaduan.tanggal_chat,
                    //     senderType: "user",
                    //     id_tiket: result.tiket_id,
                    //     userImg: this.datauser.foto,
                    //     email: this.datauser.email,
                    //     npwp: this.datauser.npwp,
                    //     kategori: result.kategori_nama
                    // })

                    //console.log(result)

                    ////logAction(`[${result.no_tiket}] ${this.datauser.nama} kirim pesan [${listMsgVal.msg}] [${JSON.stringify(listMsgVal.file)}] [${JSON.stringify(listMsgVal.img)}]`)

                    // Tambah ke list pesan
                    this.tempmsg = {
                        sender: { role_id: 3, username: this.datauser.nama },
                        file_pengaduan: (listMsgVal.file) ? `${be}/storage/${listMsgVal.file}` : null,
                        gambar_pengaduan: (listMsgVal.img) ? `${be}/storage/${listMsgVal.img}` : null,
                        type: 1,
                        message: listMsgVal.msg,
                        sent_at: sendFiles.data.pengaduan.tanggal_chat,
                        file: null,
                        img: null
                    };

                    this.tickets.map((item) => {
                        if (item.no_tiket == result.no_tiket) {
                            item.messages.push(this.tempmsg)
                        }
                    })

                    this.allmsg[result.no_tiket].push(this.tempmsg);
                    if (this.inputCari == "") this.filtered = this.tickets;
                }

                // const tempresult = this.tickets.map((el) => {
                //     if (el.no_tiket == result.no_tiket) {
                //         return el
                //     }

                // })

                // console.log('all tickets : ',this.tickets,'result : ',result)
                //console.log('wholetiket yang baru : ', tempresult)

                // Scroll ke bawah setelah kirim
                this.$nextTick(() => {
                    const parent = this.$refs.parent;
                    parent.scrollTop = parent.scrollHeight;
                });

                Swal.fire({
                    icon: "success",
                    title: "Berhasil!",
                    text: "Tiket berhasil dibuat dan dikirim.",
                    timer: 1500,
                    showConfirmButton: false
                });

                // Reset form
                this.listForm = { perihal: 0 };
                this.listInputan = {};
                this.batalBuatTiket();
            } catch (error) {
                //logAction(`${this.datauser.nama} gagal buat tiket ${JSON.stringify(error)}`)
                Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text: "Terjadi kesalahan saat membuat tiket.",
                });
            } finally {
                this.isloading = false;
                this.$refs.btnBuatTiket.disabled = false;
            }
        },

        scrollToBottom() {
            this.$nextTick(() => {
                const parent = this.$refs.parent;
                if (parent) {
                    parent.scrollTop = parent.scrollHeight;
                }
            });
        },
        getNowDateTime() {
            const now = new Date()

            const y = now.getFullYear()
            const m = String(now.getMonth() + 1).padStart(2, '0')
            const d = String(now.getDate()).padStart(2, '0')

            const hh = String(now.getHours()).padStart(2, '0')
            const mm = String(now.getMinutes()).padStart(2, '0')
            const ss = String(now.getSeconds()).padStart(2, '0')

            return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
        },

        checkWorkingHours() {
            const now = new Date();
            const hour = now.getHours();
            //console.log(hour)
            // jam operasional 8 pagi sampai 3 sore (08:00 - 15:00)
            if (this.datauser.nama == 'Test System Corporation Limited') {
                return true
            }
            if (hour < 8 || hour >= 15) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Diluar jam operasional',
                    text: 'Chat hotline hanya dapat dilakukan dari jam 8 pagi hingga 3 sore.'
                });
                return false; // hentikan fungsi utama
            }
            return true; // lanjutkan fungsi utama
        },
        async addMessage() {
            if (this.checkWorkingHours() === false) {
                return
            }
            if (this.tempchat == '' || this.tempchat == null || this.tempchat == ' ') {
                return
            }
            this.tempmsg = {
                sender: {
                    role_id: 3,
                    perusahaan: {
                        nama_perusahaan: this.datauser.nama,
                        username: this.datauser.username
                    }
                },
                file_pengaduan: null,
                gambar_pengaduan: null,
                type: 1,
                message: this.tempchat,
                sent_at: this.dateNow(),
                file: null,
                img: null
            }

            const send = await this.sendMsg(this.tempchat)
            //console.log("Send info", send)

            socket.emit("chatMessage", {
                id: 1,
                sender: this.dataperusahaan.nama_perusahaan,
                perusahaan: {
                    username: this.datauser.username,
                },
                type: 0,
                tiket: this.activeTicket,
                msg: this.tempchat,
                file: null,
                img: null,
                date: this.getDateOnly(send.data.pengaduan.tanggal_chat),
                dateTime: this.formatSimple(this.getNowDateTime()),
                senderType: "user",
                userImg: this.datauser.foto,
                email: this.datauser.email,
                npwp: this.datauser.npwp,
                wholetiket: this.currentwholetiket
            });

            // console.log({
            //     id: 1,
            //     sender: this.datauser.nama,
            //     perusahaan: {
            //         username: this.datauser.username,
            //     },
            //     type: 0,
            //     tiket: this.activeTicket,
            //     msg: this.tempchat,
            //     file: null,
            //     img: null,
            //     date: this.getDateOnly(send.pengaduan.tanggal_chat),
            //     dateTime: this.formatSimple(this.getNowDateTime()),
            //     senderType: "user",
            //     userImg: this.datauser.foto,
            //     email: this.datauser.email,
            //     npwp: this.datauser.npwp,
            //     wholetiket: this.currentwholetiket
            // })

            //logAction(`[${this.activeTicket}] ${this.datauser.nama} kirim pesan ${this.tempchat}`)
            this.messages.push(this.tempmsg);
            this.tempchat = ""
            this.tempmsg = []
            this.tickets.unshift(this.tickets.splice(parseInt(this.currentIndex), 1)[0]);
            if (this.inputCari == "") { this.filtered = this.tickets }

            this.$nextTick(() => {
                const parent = this.$refs.parent;
                parent.scrollTop = parent.scrollHeight;
            });
        },
        addFile(jenisBtnTemp) {
            if (this.checkWorkingHours() === false) {
                return
            }
            this.jenisBtn = jenisBtnTemp
            if (jenisBtnTemp == 'dok') {
                this.fileacceptlist = '.pdf'
            } else if (jenisBtnTemp == 'img') {
                this.fileacceptlist = '.png,.jpg,.jpeg,.webp'
            }

            this.$nextTick(() => {
                this.$refs.fileInput.click()
            })
        },
        async kirimFile() {
            let tempfiles = {
                gambar: null,
                file: null
            }

            var curfileType = null

            var listfiles = (this.file) ? [this.file] : Array.from(this.fileUploadList)

            if (this.file) {
                tempfiles.gambar = [this.file]
                curfileType = "gambar"
            } else if (this.fileUploadList) {
                tempfiles.file = Array.from(this.fileUploadList)
                curfileType = "file"
            }

            const response = await kirimsinglefile(listfiles, this.currentIdTiket, curfileType)

            //console.log(response)
            //console.log("isi listfile : ",listfiles)

            if (response?.status == 200) {

                const filedikirim = response.data.data
                //console.log(filedikirim)

                filedikirim.forEach(element => {
                    // const datasetup = setupdataraw({
                    //     id: this.chatactive.id,
                    //     msg: null,
                    //     file: element.file_pengaduan,
                    //     gambar: element.gambar_pengaduan,
                    //     gambar_thumb: element.gambar_pengaduan,
                    //     nama_perusahaan: this.datauser.username,
                    //     role_id: this.datauser.role_id,
                    //     user_id: this.datauser.id,
                    //     username: this.datauser.username,
                    //     kodeunik: kodeunik,
                    // });

                    this.tempmsg = {
                        sender: { role_id: 3 },
                        file_pengaduan: (element.file_pengaduan) ? `${be}/storage/${element.file_pengaduan}` : null,
                        gambar_pengaduan: (element.gambar_pengaduan) ? `${be}/storage/${element.gambar_pengaduan}` : null,
                        type: 1,
                        message: null,
                        sent_at: element.tanggal_chat,
                        file: null,
                        img: null
                    }

                    socket.emit("chatMessage", {
                        id: 1,
                        sender: this.dataperusahaan.nama_perusahaan,
                        dateTime: this.dateNow(),
                        type: 0,
                        tiket: this.activeTicket,
                        perusahaan: {
                            nama_perusahaan: this.datauser.nama,
                            username: this.datauser.username
                        },
                        msg: null,
                        file_pengaduan: element.file_pengaduan,
                        gambar_pengaduan: element.gambar_pengaduan,
                        gambar_pengaduan_thumb:element.gambar_pengaduan_thumb,
                        date: this.dateNow(),
                        senderType: "user",
                        userImg: this.datauser.foto,
                        email: this.datauser.email,
                        npwp: this.datauser.npwp,
                        wholetiket: this.currentwholetiket
                    });

                    //logAction(`[${this.activeTicket}] ${this.datauser.nama} kirim pesan [${JSON.stringify(tempfiles.file)}] [${JSON.stringify(tempfiles.gambar)}]`)

                    this.messages.push(this.tempmsg);
                    this.tempchat = ""
                    this.tempmsg = []
                    this.tickets.unshift(this.tickets.splice(parseInt(this.currentIndex), 1)[0]);
                    //console.log(this.messages)
                    this.$nextTick(() => {
                        const parent = this.$refs.parent;
                        parent.scrollTop = parent.scrollHeight;
                    });

                    this.file = null
                    this.fileUploadList = null

                    this.tutupImagePreview()

                });

                Swal.fire({
                    titleText: 'Berhasil Kirim Files',
                    text: 'Semua files berhasil dikirim',
                    icon: 'success',
                })

            } else {
                Swal.fire({
                    titleText: 'Gagal Kirim Files',
                    text: response,
                    icon: 'error',
                })
            }
        },
        async kirimFileBefore() {
            const sessionToken = getCookie('token');
            //const listImg = ["png", "jpg", "jpeg", "webp"]
            // const currentFileType = (name) => {
            //     let temp = name.split(".");
            //     return temp[temp.length - 1].toLowerCase();
            // };

            let tempfiles = {
                gambar: null,
                file: null
            }

            var curfileType = null

            var listfiles = (this.file) ? [this.file] : Array.from(this.fileUploadList)

            if (this.file) {
                tempfiles.gambar = [this.file]
                curfileType = "gambar"
            } else if (this.fileUploadList) {
                tempfiles.file = Array.from(this.fileUploadList)
                curfileType = "file"
            }

            this.file = null
            this.fileUploadList = null
            tempfiles = {
                gambar: null,
                file: null,
                thumb: null
            }
            //console.log(listfiles)

            for (const el of listfiles) {
                try {
                    var res = null
                    if (curfileType == "gambar") {
                        res = await axios.post(
                            `${be}/api/chat/${this.currentIdTiket}/send`,
                            {
                                gambar: el
                            },
                            {
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                    Authorization: `Bearer ${sessionToken}`,
                                },
                            }
                        );
                        tempfiles.gambar = `${res.data.pengaduan.gambar_pengaduan}`
                        tempfiles.thumb = `${res.data.pengaduan.gambar_pengaduan_thumb}`
                    } else if (curfileType == "file") {
                        res = await axios.post(
                            `${be}/api/chat/${this.currentIdTiket}/send`,
                            {
                                file: el
                            },
                            {
                                headers: {
                                    Accept: "application/json",
                                    "Content-Type": "multipart/form-data",
                                    Authorization: `Bearer ${sessionToken}`,
                                },
                            }
                        );
                        tempfiles.file = `${res.data.pengaduan.file_pengaduan}`
                    }

                    this.tempmsg = {
                        sender: { role_id: 3 },
                        file_pengaduan: (tempfiles.file) ? `${be}/storage/${tempfiles.file}` : null,
                        gambar_pengaduan: (tempfiles.gambar) ? `${be}/storage/${tempfiles.gambar}` : null,
                        type: 1,
                        message: null,
                        sent_at: res.data.pengaduan.tanggal_chat,
                        file: null,
                        img: null
                    }

                    //this.currentwholetiket =

                    socket.emit("chatMessage", {
                        id: 1,
                        sender: this.dataperusahaan.nama_perusahaan,
                        dateTime: this.dateNow(),
                        type: 0,
                        tiket: this.activeTicket,
                        perusahaan: {
                            nama_perusahaan: this.datauser.nama,
                            username: this.datauser.username
                        },
                        msg: null,
                        file_pengaduan: tempfiles.file,
                        gambar_pengaduan: tempfiles.gambar,
                        gambar_pengaduan_thumb: tempfiles.thumb,
                        date: this.dateNow(),
                        senderType: "user",
                        userImg: this.datauser.foto,
                        email: this.datauser.email,
                        npwp: this.datauser.npwp,
                        wholetiket: this.currentwholetiket
                    });

                    //logAction(`[${this.activeTicket}] ${this.datauser.nama} kirim pesan [${JSON.stringify(tempfiles.file)}] [${JSON.stringify(tempfiles.gambar)}]`)

                    this.messages.push(this.tempmsg);
                    this.tempchat = ""
                    this.tempmsg = []
                    this.tickets.unshift(this.tickets.splice(parseInt(this.currentIndex), 1)[0]);
                    //console.log(this.messages)
                    this.$nextTick(() => {
                        const parent = this.$refs.parent;
                        parent.scrollTop = parent.scrollHeight;
                    });

                    this.file = null
                    this.fileUploadList = null

                    this.tutupImagePreview()
                    //return res.data
                } catch (err) {
                    //logAction(`[${this.activeTicket}] ${this.datauser.nama} gagal kirim pesan ${JSON.stringify(err)}`)
                    console.error("Error:", err.response?.data || err.message);
                }
            }
        },
        tutupImagePreview() {
            this.imgPreviewState = false
            this.file = null
        },
        getDateOnly(iso) {
            if (!iso) return null
            return iso.slice(0, 10)
        },
        handleFileUpload(event) {
            let selectedFile = null;

            if (this.jenisBtn == 'img') {
                selectedFile = event.target.files[0];

                if (selectedFile) {
                    // Cek apakah file adalah gambar
                    if (!selectedFile.type.startsWith("image/")) {
                        Swal.fire({
                            icon: "error",
                            title: "Gagal!",
                            text: "File harus berupa gambar!",
                        });
                        return;
                    }

                    // Cek ukuran maksimal 2MB
                    if (selectedFile.size > 2 * 1024 * 1024) {
                        Swal.fire({
                            icon: "warning",
                            title: "Ukuran File Terlalu Besar",
                            text: "Ukuran file tidak boleh lebih dari 2MB!",
                        });
                        return;
                    }

                    this.file = selectedFile;
                    this.filePreview = URL.createObjectURL(selectedFile);
                    this.imgPreviewState = true;
                }

            } else {
                selectedFile = event.target.files;

                if (selectedFile.length > 5) {
                    Swal.fire({
                        icon: "warning",
                        title: "Terlalu Banyak File",
                        text: "Jumlah file maksimal adalah 5!",
                    });
                    return;
                }

                // Filter file yang lebih dari 2MB
                const validFiles = Array.from(selectedFile).filter(file => {
                    if (file.size > 2 * 1024 * 1024) {
                        Swal.fire({
                            icon: "warning",
                            title: "File Terlalu Besar",
                            text: `File "${file.name}" melebihi 2MB dan tidak akan diunggah.`,
                        });
                        return false;
                    }
                    return true;
                });

                this.fileUploadList = validFiles;
            }
        },

        hapusFile(key) {
            this.fileUploadList.splice(key, 1)
            if (this.fileUploadList.length < 1) {
                this.fileUploadList = null
            }
            //console.log(key)
        },
        async sendMsg(msg) {
            try {
                const result = await postdata(
                    `${be}/api/chat/${this.currentIdTiket}/send1`,
                    {
                        message: msg,
                        username: this.accountStore.user
                    }
                );

                //console.log(result)
                return result


            } catch (err) {
                console.error("Error:", err.response?.data || err.message);
            }

            //console.log(result)
            // const sessionToken = getCookie('token');
            // try {
            //     const res = await axios.post(
            //         `${be}/api/chat/${this.currentIdTiket}/send`,
            //         {
            //             message: msg, // body request
            //         },
            //         {
            //             headers: {
            //                 Accept: "application/json",
            //                 Authorization: `Bearer ${sessionToken}`,
            //             },
            //         }
            //     );
            //     return res.data
            // } catch (err) {
            //     //logAction(`[${this.activeTicket}] ${this.datauser.nama} gagal kirim pesan ${JSON.stringify(err)}`)
            //     console.error("Error:", err.response?.data || err.message);
            // }
        },

        async createTicket() {
            //const sessionToken = getCookie('token');
            // if (this.checkWorkingHours() === false) {
            //     return
            // }
            try {
                // const res = await axios.post(
                //     `${be}/api/chat/send`,
                //     {
                //         kategori_pengaduan_id: this.listForm.perihal, // body request
                //         message: "buat tiket"
                //     },
                //     {
                //         headers: {
                //             Accept: "application/json",
                //             Authorization: `Bearer ${sessionToken}`,
                //         },
                //     }
                // );

                const username = this.accountStore.user

                const res = await api2.post("/api/chat/send1", {
                    kategori_pengaduan_id: this.listForm.perihal, // body request
                    message: "buat tiket",
                    username: username
                })

                //console.log(res)

                this.tickets.unshift(
                    {
                        id: res.data.tiket_id,
                        nama_perusahaan: res.data.pengaduan.nama_perusahaan,
                        no_tiket: res.data.no_tiket,
                        status: "open",
                        perusahaan: {
                            nama_perusahaan: this.datauser.nama,
                            username: this.datauser.username

                        },
                        onepengaduan: {
                            name: res.data.kategori_nama,
                        },
                        messages: [
                            {
                                file_pengaduan: null,
                                gambar_pengaduan: null,
                                id: res.data.pengaduan.id,
                                message: res.data.pengaduan.isi_pengaduan,
                                sent_at: res.data.pengaduan.tanggal_chat,
                                sender: {
                                    role_id: 3,
                                    username: this.datauser.nama
                                }
                            }
                        ]

                    }
                )

                //logAction(`${this.datauser.nama} buat tiket ${res.data.no_tiket}`)

                this.currentIdTiket = res.data.id_tiket
                this.currentIndex = 0
                this.currentNoTiket = res.data.no_tiket
                this.allmsg[res.data.no_tiket] = []


                //console.log("create tiket", res.data);
                //console.log(this.tickets)
                return res.data
            } catch (err) {
                //logAction(`${this.datauser.nama} gagal buat tiket`)
                console.error("Error:", err.response?.data || err.message);
            }
        }
    }
};
</script>

<style scoped>
h3 {
    font-size: 11pt;
}

.file-wrap {
    border-radius: 10px;
    position: fixed;
    width: max-content;
    height: max-content;
    background-color: white;
    box-shadow: 0px 10px 40px #00000018;
    display: grid;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    margin: auto;

    .top {
        padding: 20px;

        h3 {
            font-size: 12pt;
            margin-bottom: 10px;
            font-family: poppins-bold;
        }

        .file-card {
            display: grid;
            padding: 20px;
            grid-template-columns: max-content 300px max-content;
            margin-top: 0px;

            .file-icon {
                display: flex;
                align-items: center;
                justify-content: right;

                i {
                    font-size: 25pt;
                    padding-right: 20px;
                }
            }

            .detail {
                background-color: white;

                p:first-child {
                    background-color: transparent;
                    width: 100%;
                    font-size: 10pt;
                    text-align: left;

                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 1;
                    /* tampil 1 baris saja */
                    overflow: hidden;
                    font-family: poppins-reg;
                    text-overflow: ellipsis;
                    height: auto;
                    /* biarkan tinggi otomatis */
                }

                p:last-child {
                    font-size: 11pt;
                    color: #8f8f8f;
                    background-color: transparent;
                }
            }

            .del {
                width: 50px;
                background-color: transparent;
                display: flex;
                align-items: center;
                color: red;
                justify-content: right;

                i {
                    font-size: 15pt;
                }
            }

            .excel {
                i {
                    color: green;
                }
            }

            .word {
                i {
                    color: blue;
                }
            }

            .pdf {
                i {
                    color: red;
                }
            }
        }
    }

    .bot {
        padding: 15px;
        border-top: 2px solid #f2f2f2;

        .wrap-button {
            float: right;

            button {
                padding: 5px 7px;
                border: none;
                font-size: 9pt;
                width: 100px;
                font-family: poppins-reg;
                border-radius: 7px;
            }

            button:first-child {
                border: 1px solid #f2f2f2;
            }

            button:last-child {
                border: 1px solid transparent;
                margin-left: 10px;
                background-color: #1869ff;
                color: white;
            }
        }
    }
}

.image-wrap {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background-color: rgba(0, 0, 0, 0.151);

    .tutup {
        background-color: #0000004f;
        right: 0;
        border-radius: 100%;
        height: 30px;
        width: 30px;
        margin: 10px 30px;
        position: absolute;
        display: flex;
        align-items: center;
        /* center secara vertikal */
        justify-content: center;
        cursor: pointer;
        /* center secara horizontal */

        i {
            color: white;
        }
    }


    .btns {
        width: 100%;
        padding: 5px;
        background-color: #f2f2f2;
        margin-top: 20px;
        box-sizing: border-box;
        display: grid;
        border-radius: 40px;
        grid-template-columns: repeat(2, 50%);
        column-gap: 5px;

        button {
            border: none;
            cursor: pointer;
            border-radius: 30px;
            padding: 10px;
            font-family: poppins-reg;
            font-size: 9pt;
            box-sizing: border-box;
        }

        button:first-child {
            background-color: #1869ff;
            color: white;
        }
    }
}

.image-preview {
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.137);
    position: fixed;
    width: 500px;
    height: max-content;
    background-color: #ffffff;
    border-radius: 30px;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    padding: 20px;

    img {
        object-fit: contain;
        width: 100%;
        background-color: #cccccc;
        height: max-content;
        outline: 2px solid #f2f2f2;
        max-height: 300px;
        border-radius: 20px;
    }
}

.logokemnaker {
    height: 45px;
    width: 45px;
    object-fit: contain;
    left: 0;
    right: 0;
    margin: auto auto;
    margin-bottom: 20px;
    display: block;
    background-color: transparent;
}

.buatTiket {
    padding: 20px;
    background-color: white;
    border: 2px solid #f2f2f2;
    position: fixed;
    top: 50%;
    left: 50%;
    height: max-content;
    width: min-content;
    border-radius: 10px;
    transform: translate(-50%, -50%);

    label {
        font-size: 10pt;
        display: block;
        margin-top: 15px;
        margin-bottom: 5px;
    }

    select {
        font-family: poppins-reg;
        border: none;
        outline: none;
        background-color: #f2f2f2;
        padding: 5px 7px;
    }

    textarea {
        font-family: poppins-reg;
        background-color: #f2f2f2;
        box-sizing: border-box;
        padding: 10px;
        border: 1px solid #f2f2f2;
    }

    button {
        font-family: poppins-reg;
        width: 100%;
        border: none;
        border-radius: 4px;
        padding: 10px 0;
        margin-top: 10px;
    }

    .buat {
        background-color: #1869ff;
        color: white;
        margin-bottom: 10px;
    }

    .batal {
        background-color: #f2f2f2;
    }

    input {
        font-family: poppins-reg;
        width: 100%;
        border: none;
        border-radius: 4px;
        padding: 10px 15px;
        background-color: #f2f2f2;
        box-sizing: border-box;
        margin-top: 0px;
    }
}


.container {
    background-color: white;
    width: 100%;
    height: 100vh;
    display: grid;
    grid-column: 2;
    grid-template-columns: min-content auto;

    .side {
        background-color: transparent;
        box-sizing: border-box;
        border-right: 2px solid #f2f2f2;
        display: grid;
        grid-template-rows: max-content auto;
        overflow: hidden;

        .top {
            padding: 20px;
        }

        input {
            width: 250px;
            padding: 10px 12px;
            font-family: poppins-reg;
            border: 2px solid #f2f2f2;
            background-color: white;
            border-radius: 5px;
        }

        #tktBaru {
            margin: 20px 0;
            background-color: #1869ff;
            border: none;
            color: white;
            width: 100%;
            font-size: 9pt;
            border-radius: 5px;
            padding: 10px 0;
            font-family: poppins-reg;
        }

        .filter-wrap {
            width: 100%;
            height: max-content;
            background-color: #f2f2f2;
            display: grid;
            margin-top: 20px;
            border-radius: 7px;
            padding: 4px;
            box-sizing: border-box;
            grid-template-columns: repeat(2, 50%);

            button {
                font-family: poppins-reg;
                padding: 7px 0px;
                width: 100%;
                border: none;
                border-radius: 6px;
                margin-left: 50%;
                font-size: 9pt;
                transform: translateX(-50%);
            }

            button:first-child {
                color: white;
                background-color: #1869ff;
            }

            button:nth-child(2) {
                background-color: none;
                border: none;
            }
        }

        .tikets {
            scrollbar-width: none;
            background-color: white;
            width: 100%;
            height: 100%;
            overflow-y: scroll;

            .card-tiket {
                height: max-content;
                background-color: transparent;
                margin-bottom: 0px;
                padding: 20px;
                border-top: 1px solid #f1f1f1;

                h5 {
                    font-size: 9pt;
                }

                p {
                    margin-top: 5px;
                    font-size: 10pt;
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }

                small {
                    font-family: poppins-semi;
                    color: #a0a0a0;
                }
            }

            .card-tiket:hover {
                background-color: #f2f2f2;
                cursor: pointer;
                ;
            }
        }
    }

    .containAll {
        width: 100%;
        height: 100vh;
        padding: 0px;
        box-sizing: border-box;
        background-color: transparent;
        display: grid;
        grid-template-rows: max-content auto;

        .top {
            width: 100%;
            padding: 10px;
            box-sizing: border-box;
            border-bottom: 2px solid #f2f2f2;
            height: max-content;
            display: grid;
            grid-template-columns: auto max-content;

            .settings {
                width: max-content;
                height: max-content;
                position: fixed;
                right: 0;
                top: 0;
                margin: auto;
                margin-right: 30px;
                margin-top: 70px;
                padding: 10px 10px;
                font-size: 10pt;
                background-color: white;
                border-radius: 15px;
                border: 1px solid #f2f2f2;
                box-shadow: 0px 5px 20px rgba(66, 66, 66, 0.082);

                .item-settings {
                    cursor: pointer;
                    padding: 10px 15px;
                    border-radius: 10px;
                }

                .item-settings:hover {
                    background-color: #1869ff;
                    color: white;
                }
            }

            .info {
                width: max-content;
                display: grid;
                grid-template-columns: min-content max-content;
                background-color: transparent;
                padding: 7px 10px;
                border-radius: 5px;
                font-size: 10pt;

                .ic {
                    margin-left: 5px;
                    margin-top: 5px;
                }

                p {
                    margin-left: 10px;
                    margin-top: 5px;
                }
            }

            .userProfile {
                width: max-content;
                height: min-content;
                border-radius: 10px;
                display: grid;
                padding: 10px 15px;
                cursor: pointer;
                grid-template-columns: repeat(2, max-content);
                background-color: #f2f2f2;

                img {
                    height: 40px;
                    width: 40px;
                    border-radius: 100%;
                }

                p {
                    font-family: poppins-semi;
                    font-size: 10pt;
                    display: flex;
                    /* aktifkan flexbox */
                    justify-content: center;
                    /* center horizontal */
                    align-items: center;
                    /* center vertikal */
                    padding: 0 10px;
                }
            }
        }

        .bot {
            height: 100%;
            width: 100%;
            background-color: transparent;
            display: grid;
            grid-template-rows: auto max-content;
            overflow: hidden;

            .chats {
                height: auto;
                background-color: white;
                width: 100%;
                overflow-y: scroll;

                .closed-ticket-msg {
                    margin-top: 20px;
                    margin-left: auto;
                    margin-right: auto;
                    width: 500px;
                    height: max-content;
                    background-color: #ffe8e8;
                    text-align: center;
                    border-radius: 8px;
                    color: red;
                    padding: 10px;
                    margin-bottom: 20px;
                }

                .chat-card {
                    width: 100%;
                    height: max-content;
                    margin-bottom: 0px;
                    background-color: transparent;
                    display: flex;

                    .msg {
                        padding: 10px 20px 10px 20px;
                        width: max-content;
                        max-width: 70%;
                        display: grid;
                        background-color: transparent;
                        grid-template-columns: max-content auto;

                        .msg-main {
                            .head {
                                width: max-content;
                                display: grid;
                                grid-template-columns: max-content auto;

                                .name {
                                    font-family: poppins-semi;
                                    margin-right: 20px;
                                    font-family: 11pt;
                                }

                                p small {
                                    font-size: 9pt;
                                }
                            }

                            .footer {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                width: 100%;
                                /* biar full lebar parent */
                                padding: 0px;
                                margin-top: 20px;
                                box-sizing: border-box;
                                /* opsional, biar ada ruang */

                                span {
                                    display: block;
                                    /* ubah jadi block biar bisa diatur */
                                    text-align: center;

                                    img {
                                        border-radius: 10px;
                                        max-width: 500px;
                                        width: 100%;
                                        /* biar responsive */
                                        height: auto;
                                        object-fit: contain;
                                    }
                                }
                            }

                            .file-footer:hover {
                                background-color: white;
                                color: #1869ff;
                            }

                            .file-footer {
                                cursor: pointer;
                                transition: 0.3s ease;
                                background-color: #ffffff33;
                                border-radius: 10px;
                                padding: 15px 20px;
                                display: grid;
                                grid-template-columns: repeat(2, max-content);

                                .ic-file {
                                    i {
                                        font-size: 20pt;
                                    }
                                }

                                p {
                                    max-width: 300px;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    text-wrap: nowrap;
                                    margin-top: 4px;
                                    margin-left: 20px;
                                    font-size: 10pt;
                                }
                            }
                        }
                    }

                    .profile-img img {
                        height: 40px;
                        width: 40px;
                        overflow: hidden;
                        object-fit: cover;
                        border-radius: 100%;
                    }
                }

                .user-chat {
                    width: 100%;
                    justify-content: flex-end;
                }

                .user-chat .msg-main {
                    background-color: #1869ff;
                    box-sizing: border-box;
                    color: white;
                    border-radius: 10px 0px 10px 10px;
                    padding: 15px 20px;
                    width: 100%;

                    .timedate {

                        margin-bottom: 5px;
                        width: 100%;
                    }
                }

                .agent-chat .msg-main {
                    background-color: #f2f2f2;
                    width: 100%;
                    margin-left: 20px;
                    border-radius: 0px 10px 10px 10px;
                    padding: 15px 20px;
                }
            }

            .chat-col {
                height: min-content;
                width: 100%;
                background-color: transparent;
                padding: 20px;
                box-sizing: border-box;
                display: grid;
                border-top: 2px solid #f2f2f2;
                grid-template-columns: auto max-content;

                button {
                    height: 40px;
                    width: 40px;
                    background-color: white;
                    border: none;
                    border-radius: 5px;
                    color: #696969;
                    font-size: 15pt;
                    margin-left: 20px;
                }

                button:hover {
                    background-color: #f2f2f2;
                }
            }

            textarea {
                font-family: poppins-reg;
                height: auto;
                line-height: 1.3;
                padding: 5px;
            }

            input {
                width: 97%;
                padding: 10px 12px;
                font-family: poppins-reg;
                border: 2px solid #f2f2f2;
                background-color: white;
                border-radius: 5px;
            }
        }
    }
}
</style>
